<template>
  <component :is="tag" class="landing-country-seo">
    <div class="section-inner">
      <template v-for="section in blok.body" :key="section._uid">
        <StoryblokComponent :blok="section" />
      </template>
    </div>
  </component>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div"
  },
});
</script>

<style lang="scss" scoped>
.landing-country-seo {
  @include pair-1;
  .blok-rte {
    text-align: center;
    margin-bottom: 4rem;
    @include for-desktop-up {
      max-width: 50%;
      margin-bottom: 5rem;
      margin-right: auto;
      margin-left: auto;
    }
  }
  :deep(.list-with-title .section-inner) {
    @include pair-7;
  }
}
</style>
